<template>
	<el-row class="visualization">
		<el-col :span="24">
			<div :id='containerleftPie1' class="border_bottom_mako containerleftPie"></div>
		</el-col>
		<el-col :span="24">
			<div :id='containerleftPie2' class="border_bottom_mako containerleftPie"></div>
		</el-col>
		<el-col :span="24">
			<div :id='containerleftPie3' class="containerleftPie"></div>
		</el-col>
	</el-row>
</template>

<script>
	import Api from '../../api'
	import { mapState, mapMutations, mapActions } from 'vuex'
	import echarts from 'echarts';
	export default {
		props:['unqualifiedStatus','tabType','piestatus'],

		data() {
			return {
				myChart:null
			}
		},
		computed: {
			...Vuex.mapState('supervisor', ['breadcrumbList','slider','GetReportListArr']),
			...Vuex.mapState('visualization', ['summary','trigger','reportDate','visbreadcrumbList']),
			...Vuex.mapState('breadcrumb', ['visPieColorList']),
			triggers() {
				return this.trigger.numberPie;
			},
			containerleftPie1(){
				return 'containerleftPie1' + this.getCode();
			},
			containerleftPie2(){
				return 'containerleftPie2' + this.getCode();
			},
			containerleftPie3(){
				return 'containerleftPie3' + this.getCode();
			}
		},
		watch: {
			summary() {
				if(this.summary) {
					this.initPie();
				}
			}
		},
		// updated() {
		// 	if(this.trigger.numberPie) {
		// 		this.initPie();
		// 	}
		// },
		mounted() {
			let _this = this;
			this.erd.listenTo(document.getElementsByClassName("el-main"), function (element) {
			    _this.initPie();
		    })
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType','clearRow']),
			...Vuex.mapMutations('supervisor',['currentChangesSecond','setBreadcrumbList']),
			// ...Vuex.mapActions('supervisor', ['']),
			initPie(){
				if (this.summary.ModalityTypes||this.summary.ScanTypes||this.summary.BodyParts) {
					// this.trigger.numberPie = false;
					this.getEchartsPie(this.containerleftPie1, this.summary.ModalityTypes,'设备类型','https://qc.rimagdata.com/file/939374df-4d45-4816-8c9f-2eb8252cc7d5.png');
					this.getEchartsPie(this.containerleftPie2, this.summary.ScanTypes,'扫描方式','https://qc.rimagdata.com/file/a830d428-db19-4a92-81f7-e5a4ffb41083.png');
					this.getEchartsPie(this.containerleftPie3, this.summary.BodyParts,'检查部位','https://qc.rimagdata.com/file/3e67eae6-4f47-4d3f-9de7-ab3d77ad9d18.png');
				}
			},
			getEchartsPie(id, data,text,image) {
				let _this = this;
				let dom = document.getElementById(id);
				if (dom) {
					this.myChart = echarts.init(dom);
				}
				let app = {};
				let option = null;
				let datas = [];
				let color = [];
				if(id == this.containerleftPie1) {
					color = this.visPieColorList.color1;
					data.map(res => {
						datas.push({
							name: res.ModalityType,
							value: res.Count
						})
					})
				}
				if(id == this.containerleftPie2) {
					color = this.visPieColorList.color2;
					data.map(res => {
						datas.push({
							name: res.ScanType,
							value: res.Count
						})
					})
				}
				if(id == this.containerleftPie3) {
					color = this.visPieColorList.color3;
					data.map(res => {
						datas.push({
							name: res.BodyPart,
							value: res.Count
						})
					})
				}
				option = {
					color: color,
					title:{
						text:text,
						left:"center",
						top:"55%",
						textStyle:{
							color:"#ffffff",
							fontSize:this.fontSize(0.12),
							align:"center"
						}
					},
					graphic: { // 这个属性可以在饼图内部填充图片,文字等
						elements: [{
							type: 'image',//需要填充图片,配置image,如果不需要图片可以配置其他的, 
							style: {
								image:image, //这里添加图片地址
								width: this.fontSize(0.3),
								height: this.fontSize(0.3)
							},
							left: 'center',
							top: '37%' //配置图片居中
						}]
					},
					tooltip: {
						trigger: 'item',
						textStyle:{
							fontSize:this.fontSize(0.12),
						},
						confine:true
					},
					series: [{
						name: '质控数',
						type: 'pie',
						center: ['50%', '50%'],
						radius: ['50%', '57%'],
						minAngle: 15,//最小角度
						hoverOffset: 2,
						label: {
							show:false,
							color: '#fff',
							formatter: '{b|{b}}',
							alignTo: 'labelLine',
							rich: {
								b: {
									align: 'left',
									color: '#fff'
								}
							},
							 normal: {
							   show : true
							}
						},
						labelLine: {
							length2:8
						},
						data: datas
					}]
				};;
				if(option && typeof option === "object") {
					this.myChart.setOption(option, true);
					this.myChart.off('click'); //清除联系点击
					this.myChart.on('click', (params) => {
						this.setTootipType(false);
						this.clearRow();
						this.currentChangesSecond(1);
						this.setBreadcrumbList();
						this.breadcrumbList.push(this.reportDate.data[0] + '-' + this.reportDate.data[1]);
						if(id == this.containerleftPie1) {
							this.GetReportListArr.type = '设备类型';
						} else if(id == this.containerleftPie2) {
							this.GetReportListArr.type = '扫描方式';
						} else if(id == this.containerleftPie3){
							this.GetReportListArr.type = '检查部位';
						}
						this.breadcrumbList.push(params.name);
						this.GetReportListArr.name = params.name;
						this.breadcrumbList.push("pie");
						this.GetReportListArr.status = this.piestatus;
						this.GetReportListArr.unqualified = this.unqualifiedStatus;
						this.GetReportListArr.tabType = this.tabType;
						this.$router.push("/home/supervisor/qualifiedTable");
					});
				}
				this.myChart.resize(); //区域更新
				window.addEventListener("resize", () => {
					this.myChart.resize();
				});
			}
		}
	}
</script>

<style>

</style>